import { Amplify } from "aws-amplify";
import { get, put, post } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";
import { getCurrentUser } from "aws-amplify/auth";

const authConfig = {
  Cognito: {
    userPoolId: "us-west-1_MRRH7QyfO",
    userPoolClientId: "5qt0r318huub5gh0186csj59ui",
  },
};

Amplify.configure({
  Auth: authConfig,
  API: {
    REST: {
      igniteinsights: {
        endpoint: "https://j5dk657cyb.execute-api.us-west-1.amazonaws.com/dev",
        region: "us-west-1",
      },
    },
  },
});

export async function getUser(cognitoUser) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/user?cognito_id=${cognitoUser}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function getTeamsUsers(team) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/user?team_number=${team}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function editUser(body) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = post({
      apiName: "igniteinsights",
      path: `/user`,
      options: {
        headers: {
          Authorization: authToken,
        },
        body: {
          body,
        },
      },
    });
    const response = await restOperation.response;
    return response;
  } catch (e) {
    console.log(e);
  }
}

export async function getPendingUser(role_id = "", team_number = "") {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/pending_user?role_id=${Number(
        role_id
      )}&team_number=${team_number}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}
